import { View, Text } from 'react-native'
import React from 'react'
import Svg, { Circle, Path } from 'react-native-svg'; // Import the necessary components


const LogOutIcon = ({ color, height, width }) => {
  return (
    <View>
      <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <Path d="M6.34315 6.34315C5.22433 7.46197 4.4624 8.88743 4.15372 10.4393C3.84504 11.9911 4.00346 13.5997 4.60896 15.0615C5.21447 16.5233 6.23985 17.7727 7.55544 18.6518C8.87103 19.5308 10.4178 20 12 20C13.5823 20 15.129 19.5308 16.4446 18.6518C17.7602 17.7727 18.7855 16.5233 19.391 15.0615C19.9965 13.5997 20.155 11.9911 19.8463 10.4393C19.5376 8.88743 18.7757 7.46197 17.6569 6.34315" stroke={color} stroke-linecap="round" />
        <Path d="M12 8L12 4" stroke={color} stroke-linecap="round" />
      </Svg>
    </View>
  )
}

export default LogOutIcon